import { Fragment, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Menus } from "../../constants/menus-constant";
import Button from "@mui/material/Button";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SidebarCollapseSvg, SidebarExpandSvg } from "../../assets/svgs";
import { AuthPageContainer, AuthPageHead } from "../../styles/global-styles";
import { AccordionCard, HomePageWrapper } from "./home.style";
import { permissionsHelper } from "../../helpers/permissions";

const Home = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.loginUserReducer);
    const permissions = permissionsHelper(user);

    const MenuList = Menus({ user });

    const PageIcon = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0]?.icon;

    const [expandedAccordions, setExpandedAccordions] = useState({ 0: true });

    const handleExpandAll = () => {
        const allExpanded = {};
        MenuList.slice(1).forEach((menu, index) => {
            allExpanded[index] = true;
        });
        setExpandedAccordions(allExpanded);
    };

    const handleCollapseAll = () => {
        setExpandedAccordions({});
    };

    const handleAccordionChange = (accordionIndex) => {
        setExpandedAccordions(prev => ({
            ...prev,
            [accordionIndex]: !prev[accordionIndex]
        }));
    };

    return (
        <AuthPageContainer>
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>Home</h1>
                </div>

                <div className="right mui-actions">
                    <Button variant="contained" size="small" startIcon={<SidebarExpandSvg />} onClick={handleExpandAll}>Expand All</Button>
                    <Button variant="contained" size="small" startIcon={<SidebarCollapseSvg />} onClick={handleCollapseAll}>Collapse All</Button>
                </div>
            </AuthPageHead>

            {
                MenuList && MenuList.length > 0 &&
                <HomePageWrapper>
                    {
                        MenuList.slice(1).map((menu, index) => (
                            <Fragment key={index}>
                                {
                                    menu?.subMenus && menu?.subMenus.length > 0 && permissions && permissions?.length > 0 && permissions?.some(permission => permission?.pageUrl === menu?.to) &&
                                    <Accordion className="accordion-container" expanded={expandedAccordions[index] || false} onChange={() => handleAccordionChange(index)}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            className="accordion-head"
                                        >
                                            <menu.icon className="accordion-icon" />
                                            <Typography component="span" className="accordion-label">{menu?.label}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className="accordion-body">
                                            {
                                                menu?.subMenus?.map((subMenu, subIndex) => (
                                                    <Fragment key={subIndex}>
                                                        {
                                                            permissions && permissions?.length > 0 && permissions?.some(permission => permission?.pageUrl === subMenu?.to) &&
                                                            <AccordionCard className="box-shadow" onClick={() => navigate(subMenu?.to)}>
                                                                <div className="left">
                                                                    <subMenu.icon />
                                                                </div>
                                                                <div className="right">
                                                                    <h6>{subMenu?.label}</h6>
                                                                    <p>Click here to view details</p>
                                                                </div>
                                                            </AccordionCard>
                                                        }
                                                    </Fragment>
                                                ))
                                            }

                                        </AccordionDetails>
                                    </Accordion>
                                }
                            </Fragment>
                        ))
                    }
                </HomePageWrapper>
            }
        </AuthPageContainer>
    );
};

export default Home;